import openSocket from "socket.io-client";
import { getBackendUrl } from "../config";

function connectToSocket() {
  let token = null;
  try {
    const rawToken = localStorage.getItem("token");
    token = rawToken ? JSON.parse(rawToken) : null;
  } catch (e) {
    console.error("Error reading token for socket:", e);
  }
  return openSocket(getBackendUrl(), {
    transports: ["websocket", "polling"],
    query: {
      token,
    },
  });
}

export default connectToSocket;